import { fetchApi } from 'src/_helpers/client/fetchApi'
import { buildUrl } from 'src/_helpers/buildUrl'

const PATH = '/api/open/journal_articles'

async function getAheadOfPrintByJournal(journalUuid, page = 1, perPage = 4, order = 'desc') {
  const url = buildUrl(PATH, {
    'iri[journal]': `/api/open/journals/${journalUuid}`,
    'order[publishedAt]': order,
    aheadOfPrint: true,
    page,
    perPage,
  })
  return await fetchApi(
    url,
    'GET',
    { accept: 'application/ld+json' },
    { next: { tags: [`journal_issue_ahead_of_print:${journalUuid}`] } },
  ).then(
    (response) => response,
    () => {
      throw new Error(`Failed to fetch entities: ${url}`)
    },
  )
}
async function getByUuid(uuid) {
  if (!uuid) {
    return null
  }

  const url = `${PATH}/${uuid}`

  return await fetchApi(
    url,
    'GET',
    { accept: 'application/json' },
    { next: { tags: [`journal_articles:${uuid}`] } },
  ).then(
    (response) => response,
    (error) => {
      if (error?.status === 404) {
        return null
      }

      throw new Error(`Failed to fetch journal article: ${url}`)
    },
  )
}

export const journalArticleService = {
  getAheadOfPrintByJournal,
  getByUuid,
}
